// extracted by mini-css-extract-plugin
export default {"header2":"header2_header2__rEFSh","skipMargin":"header2_skipMargin__0mMme","wide":"header2_wide__yqyoD","placeHolderShimmer":"header2_placeHolderShimmer__SbGg2"};